import { render, staticRenderFns } from "./Pie.vue?vue&type=template&id=2274dbd2"
import script from "./Pie.vue?vue&type=script&lang=js"
export * from "./Pie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2274dbd2')) {
      api.createRecord('2274dbd2', component.options)
    } else {
      api.reload('2274dbd2', component.options)
    }
    module.hot.accept("./Pie.vue?vue&type=template&id=2274dbd2", function () {
      api.rerender('2274dbd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/statisticsManagement/statisticsSurvey/Pie.vue"
export default component.exports